export default "__VITE_ASSET__CGxbVgp3__"